var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{staticClass:"input textarea",attrs:{"api-key":_vm.tinyMceApiKey,"inline":_vm.showToolbarInline,"init":{
    fixed_toolbar_container: '#' + _vm.toolbarContainer,
    menubar: false,
    statusbar: false,
    directionality : _vm.direction,
    plugins: _vm.tinyMcePlugins,
    toolbar: _vm.currentToolBar
   }},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }